import React, { useContext, useEffect } from 'react';

import AvatarLibrary from '@/3.0/library/_components/operation/assets/_components/Avatars/AvatarLibrary';
import { RightContext } from '@/components/RightProvider/context';
import { useTranslate } from '@/hooks/useTranslate';

import CommonModal from '../index';

interface SelectAvatarModalProps {
  onSelect?: (avatar: {
    avatarId: string | number;
    url: string;
    dataInfo: Record<string, any>;
  }) => void;
  onClose?: () => void;
  /**
   * 过滤器 - 用于过滤显示的数字人
   */
  filter?: (avatar: any) => boolean;
  /**
   * 是否显示自定义数字人
   */
  showCustom?: boolean;
  /**
   * 是否显示模板数字人
   */
  showTemplate?: boolean;
}

const Content: React.FC<SelectAvatarModalProps> = ({ onClose, onSelect }) => {
  const { t } = useTranslate();
  const rightContext = useContext(RightContext);
  const [isLoggedIn, setIsLoggedIn] = React.useState<boolean>(false);
  const handleSelectAvatar = (avatar: any) => {
    let result;
    if (avatar.templateCode && avatar.icon) {
      // 素材
      result = {
        avatarId: avatar.templateCode,
        url: avatar.icon,
        dataInfo: avatar,
      };
    } else {
      // 自定义
      result = {
        avatarId: avatar.id,
        url: avatar.previewUrl,
        dataInfo: avatar,
      };
    }

    onSelect?.(result);
    onClose?.();
  };
  useEffect(() => {
    (async () => {
      // 如果未登录，不请求接口
      const isLoggedIn = await rightContext.getUserLoginState({ skipLoginModal: true });
      setIsLoggedIn(isLoggedIn);
    })();
  }, []);

  if (!isLoggedIn) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
          minHeight: '400px',
        }}
      >
        <p
          style={{
            fontSize: '16px',
            fontWeight: '400',
            color: '#11111199',
          }}
        >
          {t('18432c5cd309e3b1e5dda1b438381f5d')}
        </p>
      </div>
    );
  }
  return (
    <div className="flex flex-col gap-[24px] h-full overflow-auto no-scrollbar max-h-[553px] overflow-y-auto">
      {/* <MyAvatar
        showCreate={false}
        showExtra={false}
        isLoggedIn={isLoggedIn}
        onSelect={handleSelectAvatar}
      /> */}
      <AvatarLibrary isLoggedIn={isLoggedIn} onSelect={handleSelectAvatar} />
    </div>
  );
};

export function selectAvatarModalShow(options: SelectAvatarModalProps = {}) {
  CommonModal.show((t) => ({
    width: 1170,
    title: t('merror.avatars.selectAvatar'),
    footer: false,
    customPadding: {
      x: 12,
      y: 0,
    },
    modalClassName: 'select-avatar-modal',
    content: (close) => (
      <Content
        {...options}
        onClose={() => {
          close();
          options.onClose?.();
        }}
      />
    ),
  }));
}
